import type { SerializerRegistry } from '@visualizer/types';

const version = 'v0_0_11';

const v0_0_11: SerializerRegistry = {
    version,
    binary: {},
};

export default v0_0_11;
